import "./faqPage.css";
import { React, useEffect } from "react";
import AccordionComponent from "../../../components/AccordionComponent/AccordionComponent";
import Constants from "../../../constants/Contents.json";

const ProductPage = () => {
  const staticContent = Constants.faq;
  useEffect(() => {
    // Scroll to the top of the page when this page is loaded
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="faq-page">
      <div className="productPageContainer">
        <div className="faq-card">
          <div className="mainText">{staticContent?.mainTitle}</div>
          {staticContent?.questions?.map((item, index) => (
            <AccordionComponent
              key={index}
              title={item.question}
              description={item.answer}
            />
          ))}
        </div>
      </div>
      <div className="container"></div>
    </div>
  );
};

export default ProductPage;
